import { client } from './client'
import { AttestationUrssafAi, pollAttestationVerdict } from './attestationUrssaf'

export const waitForAttestationVerdict = (globalId: string, fileUrl: string): Promise<AttestationUrssafAi> =>
  pollAttestationVerdict(fileUrl, async () => {
    const resp = await client.get(`/registration/${globalId}/`)
    return resp.data as { attestation_urssaf?: string | null; attestation_urssaf_ai?: AttestationUrssafAi }
  })
